import { QueryBuilderBase } from './QueryBuilderBase';

class TextQueryBuilderError extends Error {}

export class TextQueryBuilder extends QueryBuilderBase {

  /**
   * Check the type of the fieldName to be a string or array.
   * If array, that's great. Return it. If string, convert to array.
   *
   * @param {mixed} fieldName - string or array, hopefully!
   */
  convertFieldNameToArray(fieldName) {

    if (fieldName && !Array.isArray(fieldName) && typeof fieldName !== 'string') {
      throw new TextQueryBuilderError(`The text field to query should be a string or array. Found: ${fieldName}`);
    }

    if (typeof fieldName === 'string') return [fieldName];

    return fieldName;
  }

  ConvertFieldNameToArray(fieldName) {

    if (fieldName && !Array.isArray(fieldName) && typeof fieldName !== 'string') {
      throw new TextQueryBuilderError(`The text field to query should be a string or array. Found: ${fieldName}`);
    }

    if (typeof fieldName === 'string') return [fieldName];

    return fieldName;
  }


  /** */
  static get Operators() {
    return {
      CONTAINS: {
        name: 'contains',
        requiresOperand: true,
      },
      DOES_NOT_CONTAIN: {
        name: 'does not contain',
        requiresOperand: true,
      },
      STARTS_WITH: {
        name: 'starts with',
        requiresOperand: true,
      },
      ENDS_WITH: {
        name: 'ends with',
        requiresOperand: true,
      },
      IS_EXACTLY: {
        name: 'is exactly',
        requiresOperand: true,
      },
      IS_EMPTY: {
        name: 'is empty',
        requiresOperand: false,
      },
      IS_NOT_EMPTY: {
        name: 'is not empty',
        requiresOperand: false,
      },
    };
  }

  buildCondition(fieldNames, operand, operator) {
    const condition = {};

    switch (operator) {
      case this.constructor.Operators.CONTAINS.name:
        condition.$or = fieldNames.map(fieldName => ({ [fieldName]: { $like: `%${operand}%` } }));
        break;
      case this.constructor.Operators.STARTS_WITH.name:
        condition.$or = fieldNames.map(fieldName => ({ [fieldName]: { $like: `${operand}%` } }));
        break;
      case this.constructor.Operators.ENDS_WITH.name:
        condition.$or = fieldNames.map(fieldName => ({ [fieldName]: { $like: `%${operand}` } }));
        break;
      case this.constructor.Operators.DOES_NOT_CONTAIN.name:
        condition.$and = fieldNames.map(fieldName => ({
          $or: [
            { [fieldName]: 'null' },
            { [fieldName]: { $notlike: `%${operand}%` } },
          ],
        }));
        break;
      case this.constructor.Operators.IS_EXACTLY.name:
        condition.$or = fieldNames.map(fieldName => ({ [fieldName]: operand }));
        break;
      case this.constructor.Operators.IS_EMPTY.name:
        condition.$or = fieldNames.flatMap(fieldName => ([{ [fieldName]: 'null' }, { [fieldName]: '' }]));
        break;
      case this.constructor.Operators.IS_NOT_EMPTY.name:
        condition.$or = fieldNames.flatMap(fieldName => ([{ [fieldName]: { $ne: 'null' } }, { [fieldName]: { $ne: '' } }]));
        break;
      default:
        throw new TextQueryBuilderError(`Unsupported operator: ${operator}`);
    }

    // After constructing the condition, check if it's empty
    if ((Array.isArray(condition.$or) && condition.$or.length === 0) ||
      (Array.isArray(condition.$and) && condition.$and.length === 0) ||
      (Object.keys(condition).length === 0)) {
      return null;
    }

    return condition;
  }
}
